import { Button, Flex, Text } from "@100mslive/react-ui";
import { CrossIcon, ShareScreenIcon } from "@100mslive/react-icons";

import React from "react";
import { useHMSActions } from "@100mslive/react-sdk";
import { useTranslation } from "react-i18next";

export const ScreenshareDisplay = () => {
  const hmsActions = useHMSActions();
  const { t } = useTranslation();

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      css={{
        position: "relative",
        overflow: "hidden",
        w: "37.5rem",
        maxWidth: "80%",
        h: "100%",
        r: "$3",
        m: "0 auto",
        color: "$textPrimary",
        bg: "$surfaceDefault",
        textAlign: "center",
      }}
    >
      <ShareScreenIcon width={48} height={48} />
      <Text variant="h5" css={{ m: "$8 0" }}>
        {t("lbl_sharing_screen")}
      </Text>
      <Button
        variant="danger"
        onClick={async () => {
          await hmsActions.setScreenShareEnabled(false);
        }}
        data-testid="stop_screen_share_btn"
      >
        <CrossIcon width={18} height={18} />
        &nbsp; {t("lbl_stop_share")}
      </Button>
    </Flex>
  );
};
